module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-top-metals-remnants.16e70311.png";